/**
Copyright (c) 2023, 2024, 2025 Amica Corp.
All rights reserved.

This source code, resulting binary forms, and associated documentation
(the "Software") may only be used, modified, or distributed, with or
without modification, under the terms of a written license agreement
with Amica Corp. (the "License"). All rights to manufacture, use,
redistribute, or sell anything described herein, in whole or in part,
are granted only as explicitly permitted by such License. The receipt
or possession of the Software does not convey any of these rights.

This Software is provided "AS IS," WITHOUT WARRANTY OF ANY KIND, express
or implied, including but not limited to the implied warranties of
MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.

For additional terms, see https://amica.cloud/software-copyright/
 */

import { useDispatch, useSelector } from 'react-redux';
import { selectLoader } from 'modules/sign-in/selectors';
import { useEffect } from 'react';
import { Loader } from 'modules/common/components';
import useIsAuthenticated from 'modules/common/auth/hooks/use-is-authenticated';
import { notificationActions } from 'modules/common/notifications/slice';
import { useNavigate } from 'react-router-dom';
import { authActions } from 'modules/common/auth/slice';
import { selectAccessToken, selectTokens } from 'modules/common/auth/selectors';
import { isEmpty } from 'modules/common/helpers/object';
import openAuthWindow from 'modules/common/utils/auth';
import getDashboardItems from '../../../common/components/sidebar/dashboard-Items';

const SignInView = () => {
  const { isAuthenticated } = useIsAuthenticated();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  //
  const loading = useSelector(selectLoader);
  const tokens = useSelector(selectTokens);
  const accessToken = useSelector(selectAccessToken);
  // reset notifications
  useEffect(() => dispatch(notificationActions.resetNotification()), [isAuthenticated]);
  //
  useEffect(() => {
    if (!isAuthenticated()) {
      if (tokens && !isEmpty(tokens) && tokens?.refreshToken !== '') {
        dispatch(authActions.signOut());
      }
      openAuthWindow();
    } else {
      const dashboardItems = getDashboardItems(accessToken);
      navigate(dashboardItems[0]?.pages[0]?.href);
    }
  }, [tokens]);
  //
  return <Loader loading={loading} />;
};
//
export default SignInView;
